var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_504",
    "data-name": "Group 504",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 25,
    height: 25,
    fill: "#a9a9a9",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chalkmate_Edit",
    transform: "translate(1.259 1.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M21.6,62.885a.542.542,0,0,0-.542.542v4.815a1.624,1.624,0,0,1-1.625,1.625H4.212a1.624,1.624,0,0,1-1.625-1.625V54.112a1.628,1.628,0,0,1,1.625-1.629H9.027a.542.542,0,0,0,0-1.083H4.212A2.719,2.719,0,0,0,1.5,54.112V68.241a2.716,2.716,0,0,0,2.712,2.712H19.424a2.716,2.716,0,0,0,2.712-2.712V63.426A.542.542,0,0,0,21.6,62.885Z",
    transform: "translate(-1.5 -49.292)",
    fill: "#a9a9a9",
    stroke: "#a9a9a9",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M153.6,2.688a2.443,2.443,0,0,0-3.45,0l-9.677,9.672a.548.548,0,0,0-.141.239l-1.271,4.593a.542.542,0,0,0,.141.529.55.55,0,0,0,.529.141l4.593-1.271a.547.547,0,0,0,.239-.141l9.672-9.672a2.443,2.443,0,0,0,0-3.45ZM141.658,12.715l7.92-7.92,2.555,2.555-7.92,7.915Zm-.507,1.024,2.039,2.039-2.823.78ZM153.471,6.01l-.576.571L150.34,4.027l.576-.576a1.354,1.354,0,0,1,1.915,0l.635.635A1.36,1.36,0,0,1,153.471,6.01Z",
    transform: "translate(-133.179 -1.975)",
    fill: "#a9a9a9",
    stroke: "#a9a9a9",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9e4757ed09e9bb7e3cdc6691263d09de.svg";
export { ForwardRef as ReactComponent };